import { createFileRoute } from '@tanstack/react-router';

import { SharedDiagramGate } from '@/pages/shared-viewer/shared-diagram-gate';

export const Route = createFileRoute('/shared/$shareId')({
    component: SharedShareIdRoute,
    // Both shared viewers (crochet, grid) mount a page-level header tray
    // that owns the app-nav corner on desktop; the account corner belongs
    // to the crochet properties column / the grid tray's trailing slot.
    staticData: { ownTopLeft: true, ownTopRight: true },
});

function SharedShareIdRoute() {
    const { shareId } = Route.useParams();
    return <SharedDiagramGate source={{ kind: 'shareId', shareId }} />;
}
